/* Attariye – "Birlikte al, kazan" sepet yönlendirmesi.
   Sepetteki toplam adede göre kısa bir mesaj gösterir:
   1 ürün  -> "1 ürün daha ekleyin, sepette %2 indirim kazanın."
   2–4     -> "Sepetinize %N indirim uygulandı. 1 ürün daha ekleyin, %N+1 olsun."
   5+      -> "Sepetinize en yüksek indirim (%5) uygulandı."
   Muhteşem Kasım (1 Kasım 2026 00:00 – 1 Aralık 2026 00:00, İstanbul): bu süre boyunca
   her sepette %10 uygulandığı için yalnızca "Muhteşem Kasım: Sepetinize %10 indirim uygulandı."
   gösterilir. 1 Aralık'tan itibaren eski mesajlar kendiliğinden geri gelir.
   Gösterildiği yerler: sepet sayfası (toplamın üstü) ve "sepete eklendi" penceresi. */
(function () {
  var ICON = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D9600A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="flex:none;margin-top:.2rem"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var KASIM_BASLA = Date.parse('2026-11-01T00:00:00+03:00');
  var KASIM_BITIS = Date.parse('2026-12-01T00:00:00+03:00');

  function kasimAcik() {
    if (/[?&]kasim-onizleme=1/.test(location.search)) return true;
    var simdi = Date.now();
    return simdi >= KASIM_BASLA && simdi < KASIM_BITIS;
  }

  function message(n) {
    if (!n || n < 1) return '';
    if (kasimAcik()) return 'Muhteşem Kasım: Sepetinize <b>%10 indirim</b> uygulandı.';
    if (n >= 5) return 'Sepetinize en yüksek indirim <b>(%5)</b> uygulandı.';
    if (n === 1) return '1 ürün daha ekleyin, sepette <b>%2 indirim</b> kazanın.';
    return 'Sepetinize <b>%' + n + ' indirim</b> uygulandı. 1 ürün daha ekleyin, <b>%' + (n + 1) + '</b> olsun.';
  }

  function ensureStyle() {
    if (document.getElementById('atr-nudge-style')) return;
    var s = document.createElement('style');
    s.id = 'atr-nudge-style';
    s.textContent = '.atr-nudge{display:flex;gap:.8rem;align-items:flex-start;margin:0 0 1.2rem;padding:.9rem 1.2rem;border-radius:.6rem;background:rgba(242,123,27,.08);font-size:1.3rem;line-height:1.45;color:rgb(var(--color-foreground));text-align:left}.atr-nudge b{font-weight:700;color:#B85A0E}.atr-nudge[hidden]{display:none}.cart__blocks .atr-nudge{margin-bottom:1.6rem}';
    document.head.appendChild(s);
  }

  function slot(parent, before) {
    if (!parent) return null;
    var el = parent.querySelector(':scope > .atr-nudge');
    if (!el) {
      el = document.createElement('p');
      el.className = 'atr-nudge';
      el.setAttribute('role', 'status');
      parent.insertBefore(el, before || parent.firstChild);
    }
    return el;
  }

  function render(count) {
    ensureStyle();
    var html = message(count);
    var targets = [];
    var notif = document.getElementById('cart-notification');
    if (notif) targets.push(slot(notif, notif.querySelector('.cart-notification__links')));
    var blocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (blocks) targets.push(slot(blocks, blocks.querySelector('.js-contents')));
    targets.forEach(function (el) {
      if (!el) return;
      if (html) { el.innerHTML = ICON + '<span>' + html + '</span>'; el.hidden = false; }
      else { el.innerHTML = ''; el.hidden = true; }
    });
  }

  function refresh() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.item_count); })
      .catch(function () {});
  }

  function init() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 150); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
